import { Box, Button, Grid, Typography } from "@mui/material";
import { useRef } from "react";
import ArticlesSection from "./ArticlesSection";
import BooksSection from "./BooksSection";
import ChaptersSection from "./ChaptersSection";
import OpEdsSection from "./OpEdsSection";
import ReviewsSection from "./ReviewsSection";
import WorksSection from "./WorksSeciton";

const PublicationContainer = () => {
  const refBook = useRef();
  const refArticles = useRef();
  const refChapters = useRef();
  const refReviews = useRef();
  const refWorks = useRef();
  const refOpEds = useRef();

  return (
    <Box
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        paddingBottom: "2em",
      }}
    >
      <Box
        style={{
          width: "100%",
          background:
            "linear-gradient(180deg, #004C98 0%, rgba(90, 139, 188, 0.646736) 38.69%, rgba(255, 255, 255, 0) 100%)",
        }}
      >
        <Typography
          style={{
            padding: "32px",
            width: "100%",
            justifyContent: "flex-end",
            display: "flex",
            boxSizing: "border-box",
            marginRight: "32px",
          }}
          fontSize="32px"
          fontWeight={600}
        >
          PUBLICATIONS
        </Typography>
      </Box>
      <Box
        style={{
          maxWidth: "960px",
          width: "100%",
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Grid container>
          <Grid item xs={3}>
            <Box>
              <Typography
                style={{ margin: "24px 0px" }}
                fontSize="28px"
                fontWeight={600}
              >
                DIRECTORY
              </Typography>
            </Box>
            <Box>
              <Button
                onClick={() =>
                  refBook.current.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    inline: "nearest",
                  })
                }
              >
                <Typography fontSize="18px" fontWeight={600} color="black">
                  Books
                </Typography>
              </Button>
              <Button
                onClick={() =>
                  refArticles.current.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    inline: "nearest",
                  })
                }
              >
                <Typography fontSize="18px" fontWeight={600} color="black">
                  Journal Articles
                </Typography>
              </Button>
              <Button
                onClick={() =>
                  refChapters.current.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    inline: "nearest",
                  })
                }
              >
                <Typography fontSize="18px" fontWeight={600} color="black">
                  Chapters in Books
                </Typography>
              </Button>
              <Button
                onClick={() =>
                  refReviews.current.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    inline: "nearest",
                  })
                }
              >
                <Typography fontSize="18px" fontWeight={600} color="black">
                  Book Reviews
                </Typography>
              </Button>
              <Button
                onClick={() =>
                  refWorks.current.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    inline: "nearest",
                  })
                }
              >
                <Typography fontSize="18px" fontWeight={600} color="black">
                  Commisioned Works
                </Typography>
              </Button>
              <Button
                onClick={() =>
                  refOpEds.current.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    inline: "nearest",
                  })
                }
              >
                <Typography fontSize="18px" fontWeight={600} color="black">
                  Op-Eds
                </Typography>
              </Button>
            </Box>
            <Box></Box>
          </Grid>
          <Grid item xs={9}>
            <BooksSection ref={refBook} />
            <ArticlesSection ref={refArticles} />
            <ChaptersSection ref={refChapters} />
            <ReviewsSection ref={refReviews} />
            <WorksSection ref={refWorks} />
            <OpEdsSection ref={refOpEds} />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default PublicationContainer;
